import $ from 'jquery';
require('malihu-custom-scrollbar-plugin');
require('jquery-mousewheel');

let ScrollBar = {

    init() {
        $(".mCustomScrollbar").mCustomScrollbar({
            theme: "GE",
            mouseWheel: true,
            scrollInertia: 300,
            moveDragger: true,
            callbacks: {
                onBeforeUpdate: function () {
                    ScrollBar.UpDateScrollMargin(this);
                },
                onInit: function () {
                    ScrollBar.UpDateScrollMargin(this);
                }
            }
        });

    },
    UpDateScrollMargin(item) {
        if ($(item).find('.mCSB_container').hasClass('mCS_y_hidden')) {
            $(item).removeClass('margin-right');
        } else {
            $(item).addClass('margin-right');
        }
    }

}

export default ScrollBar;


// WEBPACK FOOTER //
// ./assets/js/libs/ScrollBar.js